import { Tooltip, Typography } from '@pwskills/rachnaui';
import { Play } from '@pwskills/rachnaui/Icons';
import React, { useState } from 'react';
import VideoModal from '@/components/common/VideoModal';
import Lock from '@/components/common/Icons/courseDescription/Lock';
import { useRouter } from 'next/router';
import { ICourseDescription } from '@/interfaces/courseDescription';
import { sendSkCurriculumVideoInteractedEvent } from '@/utils/GAEventFunction';
import { dataLayer } from '../../../../utils/common/dataLayer.utils';

type Props = {
  title: string;
  preview?: { url?: string; provider?: string };
  lectureNumber: number;
  courseDetails?: ICourseDescription | null;
};

const Lectures = ({ title, preview, lectureNumber, courseDetails }: Props) => {
  const [videoModalOpen, setVideoModalOpen] = useState<boolean>(false);
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  const sendDataLayerEvent = (videoURL: string, section: string) => {
    const dataLayerObj = {
      event: 'video_click',
      section_name: section,
      course_id: courseDetails?._id,
      video_url: videoURL,
    };
    dataLayer(dataLayerObj);
  };

  return (
    <span
      className={`${
        isDashboard
          ? 'py-4 px-6 border border-stroke-200 rounded-[1px]'
          : 'py-[17.5px] px-0 medium:!px-4 border-b !border-[#efefef] last:border-none'
      } flex bg-white justify-between gap-6  items-center  `}
    >
      <VideoModal
        title={title}
        modalOpen={videoModalOpen}
        setModelOpen={setVideoModalOpen}
        videoUrl={preview?.url || ''}
        section="curriculum"
      />
      <Typography
        component="body-regular"
        variant={isDashboard ? 'light' : 'regular'}
        className="text-[#3d3d3d]"
      >
        {`Lecture ${lectureNumber} : ${title}`}
      </Typography>
      {preview?.url ? (
        <button
          type="button"
          className="rounded-[50%] bg-orange-500 w-7 h-7 flex justify-center mx-0.5 shrink-0 items-center cursor-pointer"
          onClick={() => {
            if (preview?.url) {
              setVideoModalOpen(true);
              sendDataLayerEvent(preview?.url, 'curriculum');
              sendSkCurriculumVideoInteractedEvent({
                video_id: preview?.url,
                video_type: (preview?.provider || '').toLowerCase() || undefined,
                interaction_type: 'play',
                playback_position_sec: 0,
                video_section: 'curriculum',
                course_batch_name: courseDetails?.title || courseDetails?.name,
                course_batch_slug: courseDetails?.slug,
                course_batch_category:
                  courseDetails?.categoryDetails?.title || courseDetails?.categoryDetails?.name,
                course_batch_id: courseDetails?._id,
                course_batch_cohort_id: courseDetails?.categoryDetails?._id,
                price: courseDetails?.pricing?.IN,
                discount_percentage: courseDetails?.pricing?.discount,
                is_free: courseDetails?.pricing?.isFree,
              });
            }
          }}
        >
          <Play className="w-[14px] pl-0.5 text-white " />
        </button>
      ) : (
        <Tooltip
          text="Please purchase course to unlock"
          className="bg-gray-50 text-gray-800 shadow-dark"
        >
          <div className="rounded-[50%] bg-gray-100 w-7 h-7 flex justify-center shrink-0 items-center">
            <Lock />
          </div>
        </Tooltip>
      )}
    </span>
  );
};

export default Lectures;
